import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

//foreach
if ('NodeList' in window && !NodeList.prototype.forEach) {
            console.info('polyfill for IE11');
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }


// closest
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || 
                                Element.prototype.webkitMatchesSelector;
  }
  
  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      var el = this;
  
      do {
        if (el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }

// parentNode.append
(function (arr) {
arr.forEach(function (item) {
  if (item.hasOwnProperty('append')) {
    return;
  }
  Object.defineProperty(item, 'append', {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function append() {
      var argArr = Array.prototype.slice.call(arguments),
        docFrag = document.createDocumentFragment();

      argArr.forEach(function (argItem) {
        var isNode = argItem instanceof Node;
        docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
      });

      this.appendChild(docFrag);
    }
  });
});
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);


if (!Element.prototype.toggleAttribute) {
  Element.prototype.toggleAttribute = function(name, force) {
    if(force !== void 0) force = !!force

    if (this.hasAttribute(name)) {
      if (force) return true;

      this.removeAttribute(name);
      return false;
    }
    if (force === false) return false;

    this.setAttribute(name, "");
    return true;
  };
}

// mouseevent pollyfill for ie 9+
try {
  new MouseEvent('test');
  // No need to polyfill
} catch (e) {
// Polyfills DOM4 MouseEvent
  const MouseEventPolyfill = function (eventType, params) {
      params = params || { bubbles: false, cancelable: false };
      const mouseEvent = document.createEvent('MouseEvent');
      mouseEvent.initMouseEvent(eventType,
          params.bubbles,
          params.cancelable,
          window,
          0,
          params.screenX || 0,
          params.screenY || 0,
          params.clientX || 0,
          params.clientY || 0,
          params.ctrlKey || false,
          params.altKey || false,
          params.shiftKey || false,
          params.metaKey || false,
          params.button || 0,
          params.relatedTarget || null
      );

      return mouseEvent;
  };

  MouseEventPolyfill.prototype = Event.prototype;
  window.MouseEvent = MouseEventPolyfill;

}


